import { gql } from '@apollo/client';

export default gql`
  query offlineTaskTypes {
    offlineTaskTypes
  }
`;
